<legend *ngIf="!onlySubject && caseSubject.subject.opsubType === 'OPO'">Společnost</legend>
<legend *ngIf="!onlySubject && caseSubject.subject.opsubType === 'OFO'">Fyzická osoba</legend>
<legend *ngIf="onlySubject" class="pl-20">Osoba č. {{ caseSubjectIndex + 1 }}</legend>

<div>
  <div class="edit" *ngIf="canEdit">
    <a (click)="editFunction({ caseSubjectId: caseSubject.id, caseOwnershipId: caseOwnershipGroup.caseOwnership.id })" class="button">Upravit údaje</a>
  </div>
  <div class="flexbox-container">
    <div class="column-50">
      <label>{{ caseSubject.subject.opsubType === 'OPO' ? 'Název' : 'Jméno' }}</label>
      <div class="info">
        <a uiSref="symap.project.owners.detail" [uiParams]="{ ownerId: caseSubject.subject.lastSubjectId, tab: 'about' }">{{ caseSubject.subject | subjectName }}</a>
      </div>
      <div class="input">
        <span title="Problematický vlastník" class="ml-10 tag tag--danger tag--small is-uppercase" *ngIf="caseSubject.subject.subjectDetail.problematic">PV</span>
        <sanction-badge [detail]="caseSubject.subject.subjectDetail"></sanction-badge>
      </div>
      <label>Adresa</label>
      <div class="info">
        {{ { street:caseSubject.ulice, houseNumber: caseSubject.cisloDomovni, streetNumber: caseSubject.cisloOrientacni, neighbourhood: caseSubject.castObce, municipality: caseSubject.obec, cpCe: caseSubject.cpCe } | fullstreet }}<br/>
        <span *ngIf="caseSubject.castObce && caseSubject.castObce !== caseSubject.obec && caseSubject.ulice">{{ caseSubject.castObce }}<br/></span>
        {{ { postCode: caseSubject.psc, municipality: caseSubject.obec, district: caseSubject.mestskyObvod } | fullmunicipality }}
      </div>
      <div *ngIf="caseSubject.dorucovaciUlice || caseSubject.dorucovaciCisloDomovni || caseSubject.dorucovaciCisloOrientacni || caseSubject.dorucovaciObec">
        <label>Doručovací adresa</label>
        <div class="info">
          {{ {street:caseSubject.dorucovaciUlice, houseNumber: caseSubject.dorucovaciCisloDomovni, streetNumber: caseSubject.dorucovaciCisloOrientacni, neighbourhood: caseSubject.dorucovaciCastObce, cpCe: caseSubject.dorucovaciCpCe } | fullstreet }}<br/>
          {{ caseSubject.dorucovaciPsc | postCode}} {{ caseSubject.dorucovaciObec }}
        </div>
      </div>
      <div *ngIf="caseSubject.subject.opsubType === 'OPO'">
        <label>IČ</label><div class="info">{{ caseSubject.identificationNumber || caseSubject.subject.ico }}</div>
        <label>DIČ</label><div class="info">{{ caseSubject.dic }}</div>
        <label>Zápis</label><div class="info">
        {{ caseSubject.businessRegisterRegionalCourt?.name || 'registr' }},
        oddíl{{ caseSubject.businessRegisterSection ? ' ' + caseSubject.businessRegisterSection : '' }},
        vložka{{ caseSubject.businessRegisterEntry ? ' ' + caseSubject.businessRegisterEntry : '' }}</div>
      </div>
      <div *ngIf="caseSubject.subject.opsubType !== 'OPO'">
        <label>R.Č.</label><div class="info">{{ caseSubject.personalIdentificationNumber }}</div>
        <label>Datum narození</label><div class="info">{{ caseSubject.dateOfBirth| date: 'd.M.yyyy' }}</div>
      </div>
      <label>Telefon</label><div class="info">{{ caseSubject.phoneNumber }}</div>
      <label>E-mail</label><div class="info">{{ caseSubject.email }}</div>
      <label>Datová schránka</label><div class="info">{{ caseSubject.databoxId }}</div>
    </div>
    <div class="column-50">
      <label>Zastupující</label>
      <div class="info">
        <span style="display: block" *ngFor="let person of caseSubject.actingPersons">
          {{ {
            titulZaJmenem: person.degreeAfter,
            jmeno: person.firstName,
            prijmeni: person.surname,
            titulPredJmenem: person.titleBefore
          } | subjectName }}</span>
      </div>

      <label>Plná moc</label><div class="info">{{ caseSubject.powerOfAttorneyDate | date: 'd.M.yyyy' }}</div>

      <div *ngIf="!onlySubject">
        <label>Podíl</label>
        <div class="info" *ngIf="caseOwnershipGroup.caseOwnerships.length === 1">
          {{ caseOwnershipGroup.caseOwnership.ownership.podilCitatel + '/' + caseOwnershipGroup.caseOwnership.ownership.podilJmenovatel }}
        </div>
        <div class="info" *ngIf="caseOwnershipGroup.caseOwnerships.length > 1">
          <ng-container *ngFor="let caseOwnership of caseOwnershipGroup.caseOwnerships">
            {{ caseOwnership.ownership.podilCitatel + '/' + caseOwnership.ownership.podilJmenovatel }}
            <ng-container *ngIf="caseOwnership.ownership.title">
              (LV <a uiSref='symap.project.titles.detail' [uiParams]="{ caseSubjectId: caseSubject.id, id: caseOwnership.ownership.title.id, tab: null }" title='{{ caseOwnership.ownership.title.area.name }}'>{{ caseOwnership.ownership.title.lv }}</a> - {{ caseOwnership.ownership.title.area.name }})
            </ng-container>
            <ng-container *ngIf="!caseOwnership.ownership.title">
              (LV {{ caseOwnership.ownership.lv }})
            </ng-container>
            <br>
          </ng-container>
        </div>
      </div>

      <div *ngIf="!onlySubject || !caseOwnershipGroup.caseOwnership.singlePayment">
        <div *ngIf="caseSubject.paymentType === 'X' || !caseSubject.paymentType">
          <label>Způsob platby</label><div class="info">Neurčeno</div>
        </div>
        <div *ngIf="caseSubject.paymentType === 'M'">
          <label>Způsob platby</label><div class="info">Poštovní poukázkou</div>
        </div>
        <div *ngIf="caseSubject.paymentType === 'B'">
          <label>Způsob platby</label><div class="info">Bankovním převodem</div>
          <label>Číslo B.Ú.</label><div class="info">{{ caseSubject.accountNumber && caseSubject.bankCode ? caseSubject.accountNumber + "/" + caseSubject.bankCode : '' }}</div>
          <label>Var. symbol</label><div class="info">{{ caseSubject.variableSymbol }}</div>
        </div>
      </div>

      <div *ngIf="!onlySubject">
        <div *ngIf="obligationType === 'SalesContractLiability' || obligationType === 'NonGratuitousTransferContractLiability' || obligationType === 'ExchangeContractLiability'">
          <label>Kupní cena</label>
          <div class="info" *ngIf="caseOwnershipGroup.sumPrice !== null">{{ caseOwnershipGroup.sumPrice | number | price }}<br/>{{ caseOwnershipGroup.sumPriceInWords }}</div>
        </div>
        <div *ngIf="obligationType === 'GiftContractLiability' || obligationType === 'GratuitousTransferContractLiability'">
          <label>Účetní cena</label>
          <div class="info">{{ caseOwnershipGroup.sumPrice | number | price }}<br/>{{ caseOwnershipGroup.sumPriceInWords }}</div>
        </div>
        <div *ngIf="caseOwnershipGroup.sumEasementPrice !== undefined">
          <label>Cena služebnosti</label>
          <div class="info">{{ caseOwnershipGroup.sumEasementPrice | number | price}}<br/>{{ caseOwnershipGroup.sumEasementPriceInWords }}</div>
        </div>
        <div *ngIf="obligationType === 'RentalContractShorterThan1YearLiability' || obligationType === 'RentalContractLongerThan1YearLiability' || obligationType === 'RentalContractCommonLiability'">
          <label *ngIf="caseOwnershipGroup.sumLandPrice">Nájem</label>
          <div *ngIf="caseOwnershipGroup.sumLandPrice" class="info">{{ caseOwnershipGroup.sumLandPrice | number | price }}</div>
          <label *ngIf="caseOwnershipGroup.sumCompensationPrice">Náhrady</label>
          <div *ngIf="caseOwnershipGroup.sumCompensationPrice" class="info">{{ caseOwnershipGroup.sumCompensationPrice | number | price }}</div>
          <label>Celkem</label>
          <div class="info">
            {{ caseOwnershipGroup.sumPrice | number | price }}
            <span *ngIf="manualRentPriceSet" class="info ml-5"><i class="fa fa-exclamation-triangle color-red"></i> Upravená cena za případ</span>
            <br/>{{ caseOwnershipGroup.sumPriceInWords }}
          </div>
        </div>
        <div *ngIf="caseOwnershipGroup.caseOwnership.easementFutureContractNumber">
          <label>Číslo SOSB</label><div class="info">{{ caseOwnershipGroup.caseOwnership.easementFutureContractNumber }}</div>
        </div>
        <div *ngIf="caseOwnershipGroup.caseOwnership.easementFutureContractStatus">
          <label>Stav SOSB</label><div class="info">{{ caseOwnershipGroup.caseOwnership.easementFutureContractStatus }}</div>
        </div>
      </div>

      <div *ngIf="obligationBonusPeriod || caseSubject.bonusPrice">
        <label>Akcelerační příplatek</label><div class="info" *ngIf="caseSubject.bonusPrice !== undefined">{{ caseSubject.bonusPrice | number | price}}</div>
      </div>
      <div *ngIf="caseSubject.signatureVerificationPrice !== undefined">
        <label>Příplatek za ověření</label><div class="info">{{ caseSubject.signatureVerificationPrice | number | price }}</div>
      </div>
      <div *ngIf="caseOwnershipGroup.parentCaseOwnership !== undefined">
        <label>Nadřazený subjekt</label><div class="info">{{ caseOwnershipGroup.parentCaseOwnership | parentCaseOwnershipName }}</div>
      </div>
    </div>
  </div>
</div>
